module.exports = __webpack_public_path__ + "img/icon-chevron-down.8fdc5c28.svg";